module.exports = __webpack_public_path__ + "img/contato.e8f4faef.svg";